import * as React from 'react'
import { css } from 'styled-components/macro'

/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = 'div'

interface Props extends React.ComponentPropsWithoutRef<typeof Root> {
  /**
   * A "weak" divider is thin and uses a light color. A "strong" divider is
   * thicker and uses the brandblue:main color.
   */
  variant?: 'weak' | 'medium' | 'strong'
}

function Divider(props: Props, ref: React.ForwardedRef<React.ElementRef<typeof Root>>) {
  const { variant = 'weak', ...rest } = props

  return <Root ref={ref} {...rest} css={[styles.root, styles.variant[variant]] as any} />
}

const styles = {
  root: css`
    margin: 0px;
    flex-shrink: 0;
    border-style: solid;
  `,

  variant: {
    weak: css`
      border-width: 0 0 1px;
      border-color: var(--border-color);
    `,
    medium: css`
      border-width: 0 0 1px;
      border-color: var(--color-randblue-main);
    `,
    strong: css`
      border-width: 0 0 3px;
      border-color: var(--color-randblue-main);
    `,
  },
}

export default React.forwardRef(Divider)
